import { DataVizColors } from '@carto/kepler.gl/constants'
import { KeplerLayer } from 'features/builder/types'
import rgbToHex, { hexToRGB } from 'features/common/utils/colors'

/**
 * Generates colors from Keplers DataVizColors that are not used by other layers.
 */
export function createNewLayerColorGenerator(otherLayers: KeplerLayer[]): () => number[] {
  const allColors = Object.values(DataVizColors as Record<string, string>).map((color) => color.toLowerCase())
  const usedColors = otherLayers
    .flatMap((layer) => [layer.config.color, layer.config.visConfig.strokeColor])
    .filter(Boolean)
    .map(rgbToHex)
    .map((color) => color.toLowerCase())

  const availableColors = allColors.filter((color) => !usedColors.includes(color))

  const colorsToUse = availableColors.length ? availableColors : allColors
  let index = 0
  return () => hexToRGB(colorsToUse[index++ % colorsToUse.length])
}
